import { api } from '@/api/core';
import { CASES_LIST_TAG, CHAT_HISTORY_LIST_TAG } from '@/api/constants';

/** Which of a case's chats come along with it. `SELECTED` clones only the chosen ones. */
export type CaseChatsToClone = 'NONE' | 'SELECTED' | 'ALL';

export interface CloneChatRequest {
  chatIdToClone: string;
  globalAdminAsUser?: string;
}

/** The clone, in the Benchmarks organisation. */
export interface CloneChatResponse {
  newChatId: string;
}

export interface CloneMatterRequest {
  matterIdToClone: string;
  /** Omitted clones all of the matter's chats, `[]` clones none of them. */
  matterChatIdsToClone?: string[];
}

/** The clone and its chats, in the Benchmarks organisation. */
export interface CloneMatterResponse {
  newMatterId: string;
  newMatterChatIds: string[];
}

const cloneToBenchmarkingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    cloneChatToBenchmarking: builder.mutation<CloneChatResponse, CloneChatRequest>({
      query: (body) => ({
        url: 'debug/clone-chat',
        method: 'POST',
        body,
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
      }),
      invalidatesTags: () => [{ type: CHAT_HISTORY_LIST_TAG }],
      extraOptions: { maxRetries: 0 },
    }),
    cloneMatterToBenchmarking: builder.mutation<CloneMatterResponse, CloneMatterRequest>({
      query: (body) => ({
        url: 'debug/clone-matter',
        method: 'POST',
        body,
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
      }),
      invalidatesTags: () => [{ type: CASES_LIST_TAG }, { type: CHAT_HISTORY_LIST_TAG }],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useCloneChatToBenchmarkingMutation, useCloneMatterToBenchmarkingMutation } = cloneToBenchmarkingApi;
